<template>
  <div>
    <Header :headerTitle="$t('m.personalData.title')" :hasBackBtn="true" :rightTitle="$t('m.personalData.save')" :onRightBtnClick="onsave" :iconShow="true"></Header>
    <header>
      <ul>
        <li>
          <strong>{{$t('m.personalData.name')}}</strong>
          <input type="text" :placeholder="$t('m.personalData.placeholderName')" v-model="userInfo.name">
        </li>
        <li>
          <strong>{{$t('m.personalData.gender')}}</strong>
          <select ref="select" v-model="userInfo.gender">
            <option value="1" selected>{{$t('m.personalData.male')}}</option>
            <option value="2">{{$t('m.personalData.female')}}</option>
          </select>
        </li>
        <li @click="phone()">
          <strong>{{$t('m.personalData.phone')}}</strong>
          <input
            type="text"
            :placeholder="$t('m.personalData.placeholderPhone')"
            disabled
            style="background-color:#fff"
            v-model="userInfo.phone"
          >
         <img  src="../../assets/img/zhankai.png"/>
        </li>
        <li @click="cardNo()">
          <strong>{{$t('m.personalData.licenseNumber')}}</strong>
          <input
            type="text"
            readonly
           :placeholder="$t('m.personalData.placeholderCarNo')"
            disabled
            style="background-color:#fff"
            v-model="userInfo.licenseplate"
          >
          <img src="../../assets/img/zhankai.png">
        </li>
      </ul>
    </header>
    <!-- 提示信息 -->
    <Tip :message="message" :type="tipType" :show="tipShow"></Tip>
  </div>
</template>
<script>
import { userEdit, userInfo } from "../../api/user.js";
export default {
  name: "personalData",
  data() {
    return {
      userInfo: {
        name: "", //昵称
        phone: "", //电话
        token: "", //token
        gender: "1", //性别
        vipCardId: "",
        licenseplate: "" //车牌号
      },
      message: "", //提示信息
      tipShow: "0", //是否提示
      tipType: "", //提示类型
      authTitle: ''
    };
  },
  methods: {
    //修改方法
    onsave: function() {
      userEdit({
        gender: this.userInfo.gender,
        name: this.userInfo.name
      }).then(
        response => {
          if (response.data.status == 200) {
            this.tipShow = "1" + Math.random() * 1000;
            this.message = this.$t('m.personalData.successMeassage');
            this.tipType = "success";
          } else {
            this.tipShow = "1" + Math.random() * 1000;
            this.message = response.data.message;
            this.tipType = "warning";
          }
        },
        err => {
          reject(err);
        }
      );
    },
    //获取数据
    loadUserInfo: function() {
      userInfo().then(
        response => {
          if (response.data.status == 200) {
            this.userInfo = response.data.result;

            if(this.userInfo.authStatus && this.userInfo.authStatus === 1) {
              this.authTitle = '未认证'
            }
            if(this.userInfo.authStatus && this.userInfo.authStatus === 2) {
              this.authTitle = '审核中'
            }
            if(this.userInfo.authStatus && this.userInfo.authStatus === 3) {
              this.authTitle = '已认证'
            }
            if(this.userInfo.authStatus && this.userInfo.authStatus === 4) {
              this.authTitle = '认证失败'
            }
            if(this.userInfo.authStatus && this.userInfo.authStatus === 5) {
              this.authTitle = '解除绑定'
            }

            this.userInfo.licenseplate = this.userInfo.licenseplate ? (this.userInfo.licenseplate + '(' + this.authTitle + ')') : '未绑定车辆'
          } else {
            this.tipShow = "1" + Math.random() * 1000;
            this.message = response.data.message;
            this.tipType = "warning";
          }
        },
        err => {
          reject(err);
        }
      );
    }, //手机号操作
    phone: function() {
      this.onsave();
      this.$router.push("/changeMobile");
    }, //车牌号修改
    cardNo: function() {
      // this.onsave();
      if(this.userInfo.licenseplate) {
        this.$router.push("/vehicleLicenseAuth");
      }
    }
  },
  created() {
    this.loadUserInfo();

  },
  //加载事件
  mounted() {
    console.log(this.$refs.select)
  }
};
</script>

<style scoped>
header {
  margin: 0 auto;
  padding: 0px;
}
header ul {
  padding-inline-start: 0px;
}
header ul li {
  list-style: none;
  border-bottom: 1px solid #e7e7e7;
  padding: 6px 15px;
}
header ul li strong {
  font-size: 14px;
  font-family: "宋体";
  display: inline-block;
  float: left;
  padding-top: 5px;
  width: 22%;
  text-align: left;
}
header ul li input {
  font-size: 14px;
  width: 72%;
  border: 0px;
  height: 33px;
  text-align: right;
  padding-right: 10px;
}
header ul li select {
  font-size: 14px;
  width: 74%;
  border: 0px;
  height: 33px;
  background-color: #fff;
  text-align: right;
  padding-right: 15px;
}
header ul li select {
  
  /*很关键：将默认的select选择框样式清除*/
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;

  /*在选择框的最右侧中间显示小箭头图片*/
  background: url("../../assets/img/zhankai.png") no-repeat scroll right center
    transparent;

  /*为下拉小箭头留出一点位置，避免被文字覆盖*/
  /* padding-right: 14px; */
}

/*清除ie的默认选择框样式清除，隐藏下拉箭头*/
header ul li select::-ms-expand {
  display: none;
}

button {
  width: 30%;
  border-radius: 3px;
  border: 0px;
  border: 1px solid #efefef;
  line-height: 30px;
}
</style>
